require('./bootstrap');

import Vue from 'vue'
import VueRouter from 'vue-router'
import HighchartsVue from 'highcharts-vue'
import VueScrollactive from 'vue-scrollactive';
import VTooltip from 'v-tooltip'
import {filtersMixin} from './filters';

Vue.use(VTooltip)
VTooltip.options.defaultTrigger = 'hover click';
Vue.use(VueScrollactive)
Vue.use(VueRouter)
Vue.use(HighchartsVue)

import App from './views/App'
import Home from './views/Home'
import Member from './views/Member'
import Compare from './views/Compare'
import About from './views/About'

const router = new VueRouter({
  mode: 'history',
  scrollBehavior (to, from, savedPosition) {
    return { x: 0, y: 0 }
  },
  routes: [
      {
          path: '/',
          name: 'home',
          component: Home
      },
      {
        path: '/compare',
        name: 'compare',
        component: Compare
      },
      {
        path: '/about',
        name: 'about',
        component: About
      },
      {
        path: '/:name/:year?',
        name: 'member',
        component: Member
      },
  ],
});

Vue.mixin(filtersMixin);
const app = new Vue({
  el: '#app',
  components: { App },
  router,
});

(function() {
function areScrollbarsVisible() {
    var scrollableElem = document.createElement('div'),
        innerElem = document.createElement('div');
    scrollableElem.style.width = '30px';
    scrollableElem.style.height = '30px';
    scrollableElem.style.overflow = 'scroll';
    scrollableElem.style.borderWidth = '0';
    innerElem.style.width = '30px';
    innerElem.style.height = '60px';
    scrollableElem.appendChild(innerElem);
    document.body.appendChild(scrollableElem); // Elements only have width if they're in the layout
    var diff = scrollableElem.offsetWidth - scrollableElem.clientWidth;
    document.body.removeChild(scrollableElem);
    return diff > 0;
}

window.addEventListener('load', function() {
    // Show scrollbars if they're hidden.
    if (!areScrollbarsVisible()) {
        document.body.classList.add('force-show-scrollbars');
    }
});

})();